export default function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">

        <h1>Privacy Policy</h1>

        <p>
          This Privacy Policy explains how ISTP Overseas Education
          collects, uses, and protects your information when you use
          our website and services.
        </p>

        <h2>Information We Collect</h2>

        <p>
          We may collect personal information such as:
        </p>

        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Educational interests</li>
          <li>Booking and consultation details</li>
        </ul>

        <h2>How We Use Information</h2>

        <p>
          We use collected information to:
        </p>

        <ul>
          <li>Provide counselling services</li>
          <li>Respond to enquiries</li>
          <li>Schedule consultations</li>
          <li>Send email and WhatsApp notifications</li>
          <li>Improve our services</li>
        </ul>

        <h2>Data Protection</h2>

        <p>
          We implement appropriate security measures to protect your
          personal information from unauthorized access or disclosure.
        </p>

        <h2>Third-Party Services</h2>

        <p>
          We may use third-party services including email providers,
          WhatsApp Cloud API, hosting providers, and analytics tools
          to operate our platform.
        </p>

        <h2>Contact Us</h2>

        <p>
          If you have any questions regarding this Privacy Policy,
          please contact ISTP Overseas Education.
        </p>

      </div>
    </div>
  );
}